/* eslint-disable max-len */

import {FY} from '../../../../pages/esgManager/constants/FrameWorksConst';

// detailsOfTheListedEntity----------------------------------
export const DetailsOfTheListedEntityKey = {
  DOLE_QUESTION_1: 'doleQuestion1',
  DOLE_QUESTION_2: 'doleQuestion2',
  DOLE_QUESTION_3: 'doleQuestion3',
  DOLE_QUESTION_4: 'doleQuestion4',
  DOLE_QUESTION_5: 'doleQuestion5',
  DOLE_QUESTION_6: 'doleQuestion6',
  DOLE_QUESTION_7: 'doleQuestion7',
  DOLE_QUESTION_8: 'doleQuestion8',
  DOLE_QUESTION_9: 'doleQuestion9',
  DOLE_QUESTION_10: 'doleQuestion10',
  DOLE_QUESTION_11: 'doleQuestion11',
  DOLE_QUESTION_12: 'doleQuestion12',
  DOLE_QUESTION_13: 'doleQuestion13',
  DOLE_QUESTION_14: 'doleQuestion14',
  DOLE_QUESTION_15: 'doleQuestion15',
  DOLE_QUESTION_16: 'doleQuestion16',
  DOLE_QUESTION_17: 'doleQuestion17',
  DOLE_QUESTION_18: 'doleQuestion18',
  DOLE_QUESTION_19: 'doleQuestion19',
  DOLE_QUESTION_20: 'doleQuestion20',
  DOLE_QUESTION_21: 'doleQuestion21'
};

export const DetailsOfTheListedEntityLabel = {
  DOLE_QUESTION_1: '',
  DOLE_QUESTION_2: '',
  DOLE_QUESTION_3: '',
  DOLE_QUESTION_4: '',
  DOLE_QUESTION_5: '',
  DOLE_QUESTION_6: '',
  DOLE_QUESTION_7: '',
  DOLE_QUESTION_8: '',
  DOLE_QUESTION_9: '',
  DOLE_QUESTION_10: '',
  DOLE_QUESTION_11: '',
  DOLE_QUESTION_12: 'Name',
  DOLE_QUESTION_13: 'Telephone',
  DOLE_QUESTION_14: 'Email',
  DOLE_QUESTION_15: '',
  DOLE_QUESTION_16: '',
  DOLE_QUESTION_17: '',
  DOLE_QUESTION_18: 'Designation'
};

// productsServices----------------------------------
export const ProductsServicesKey = {
  PS_QUESTION_1: 'psQuestion1',
  PS_QUESTION_2: 'psQuestion2',
  PS_QUESTION_3: 'psQuestion3',
  PS_QUESTION_4: 'psQuestion4',
  PS_QUESTION_5: 'psQuestion5',
  PS_QUESTION_6: 'psQuestion6',
  PS_QUESTION_7: 'psQuestion7',
  PS_QUESTION_8: 'psQuestion8',
  PS_QUESTION_9: 'psQuestion9',
  PS_QUESTION_10: 'psQuestion10',
  PS_QUESTION_11: 'psQuestion11',
  PS_QUESTION_12: 'psQuestion12',
  PS_QUESTION_13: 'psQuestion13',
  PS_QUESTION_14: 'psQuestion14',
  PS_QUESTION_15: 'psQuestion15'
};

export const ProductsServicesLabel = {
  PS_HEADINGLABEL_1:
    '16. Details of business activities (accounting for 90% of the turnover):',
  PS_HEADINGLABEL_2:
    '17. Products/Services sold by the entity (accounting for 90% of the entity’s Turnover) :',
  PS_HEADING_1: 'Product / Service',
  PS_HEADING_2: 'NIC Code',
  PS_HEADING_3: '% of total Turnover contributed',
  PS_HEADING_4: 'Description of Main Activity',
  PS_HEADING_5: 'Description of Business Activity',
  PS_HEADING_6: '% of Turnover of the  entity',
  PS_QUESTION_1: '',
  PS_QUESTION_2: '',
  PS_QUESTION_3: '',
  PS_QUESTION_4: '',
  PS_QUESTION_5: '',
  PS_QUESTION_6: '',
  PS_QUESTION_7: '',
  PS_QUESTION_8: '',
  PS_QUESTION_9: '',
  PS_QUESTION_10: '',
  PS_QUESTION_11: '',
  PS_QUESTION_12: ''
};

// operations----------------------------------
export const OperationsKey = {
  O_QUESTION_1: 'oQuestion1',
  O_QUESTION_2: 'oQuestion2',
  O_QUESTION_3: 'oQuestion3',
  O_QUESTION_4: 'oQuestion4',
  O_QUESTION_5: 'oQuestion5',
  O_QUESTION_6: 'oQuestion6',
  O_QUESTION_7: 'oQuestion7',
  O_QUESTION_8: 'oQuestion8',
  O_QUESTION_9: 'oQuestion9',
  O_QUESTION_10: 'oQuestion10',
  O_QUESTION_11: 'oQuestion11',
  O_QUESTION_12: 'oQuestion12'
};

export const OperationsLabel = {
  O_HEADINGLABEL_1:
    '18. Number of locations where plants and/or operations/offices of the entity are situated:',
  O_HEADINGLABEL_2: '19. Markets served by the entity :',
  O_HEADING_1: 'a. Number of locations',
  O_HEADING_2:
    'b. What is the contribution of exports as a percentage of the total turnover of the entity? ',
  O_HEADING_3: 'c. A brief on types of customers :',
  O_QUESTION_1: 'Number of plants (National)',
  O_QUESTION_2: 'Number of offices (National)',
  O_QUESTION_3: 'Number of plants (International)',
  O_QUESTION_4: 'Number of offices (International)',
  O_QUESTION_5: 'Total (National)',
  O_QUESTION_6: 'Total (International)',
  O_QUESTION_7: 'National (No. of States)',
  O_QUESTION_8: 'International (No. of Countries)',
  O_QUESTION_9: '',
  O_QUESTION_10: ''
};

// employees----------------------------------

export const EmployeesKey = {
  E_QUESTION_1: 'eQuestion1',
  E_QUESTION_2: 'eQuestion2',
  E_QUESTION_3: 'eQuestion3',
  E_QUESTION_4: 'eQuestion4',
  E_QUESTION_5: 'eQuestion5',
  E_QUESTION_6: 'eQuestion6',
  E_QUESTION_7: 'eQuestion7',
  E_QUESTION_8: 'eQuestion8',
  E_QUESTION_9: 'eQuestion9',
  E_QUESTION_10: 'eQuestion10',
  E_QUESTION_11: 'eQuestion11',
  E_QUESTION_12: 'eQuestion12',
  E_QUESTION_13: 'eQuestion13',
  E_QUESTION_14: 'eQuestion14',
  E_QUESTION_15: 'eQuestion15',
  E_QUESTION_16: 'eQuestion16',
  E_QUESTION_17: 'eQuestion17',
  E_QUESTION_18: 'eQuestion18',
  E_QUESTION_19: 'eQuestion19',
  E_QUESTION_20: 'eQuestion20',
  E_QUESTION_21: 'eQuestion21',
  E_QUESTION_22: 'eQuestion22',
  E_QUESTION_23: 'eQuestion23',
  E_QUESTION_24: 'eQuestion24',
  E_QUESTION_25: 'eQuestion25',
  E_QUESTION_26: 'eQuestion26',
  E_QUESTION_27: 'eQuestion27',
  E_QUESTION_28: 'eQuestion28',
  E_QUESTION_29: 'eQuestion29',
  E_QUESTION_30: 'eQuestion30',
  E_QUESTION_31: 'eQuestion31',
  E_QUESTION_32: 'eQuestion32',
  E_QUESTION_33: 'eQuestion33',
  E_QUESTION_34: 'eQuestion34',
  E_QUESTION_35: 'eQuestion35',
  E_QUESTION_36: 'eQuestion36',
  E_QUESTION_37: 'eQuestion37',
  E_QUESTION_38: 'eQuestion38',
  E_QUESTION_39: 'eQuestion39',
  E_QUESTION_40: 'eQuestion40',
  E_QUESTION_41: 'eQuestion41',
  E_QUESTION_42: 'eQuestion42',
  E_QUESTION_43: 'eQuestion43',
  E_QUESTION_44: 'eQuestion44',
  E_QUESTION_45: 'eQuestion45',
  E_QUESTION_46: 'eQuestion46',
  E_QUESTION_47: 'eQuestion47',
  E_QUESTION_48: 'eQuestion48',
  E_QUESTION_49: 'eQuestion49',
  E_QUESTION_50: 'eQuestion50',
  E_QUESTION_51: 'eQuestion51',
  E_QUESTION_52: 'eQuestion52',
  E_QUESTION_53: 'eQuestion53',
  E_QUESTION_54: 'eQuestion54',
  E_QUESTION_55: 'eQuestion55',
  E_QUESTION_56: 'eQuestion56',
  E_QUESTION_57: 'eQuestion57',
  E_QUESTION_58: 'eQuestion58',
  E_QUESTION_59: 'eQuestion59',
  E_QUESTION_60: 'eQuestion60',
  E_QUESTION_61: 'eQuestion61',
  E_QUESTION_62: 'eQuestion62',
  E_QUESTION_63: 'eQuestion63',
  E_QUESTION_64: 'eQuestion64',
  E_QUESTION_65: 'eQuestion65',
  E_QUESTION_66: 'eQuestion66',
  E_QUESTION_67: 'eQuestion67',
  E_QUESTION_68: 'eQuestion68',
  E_QUESTION_69: 'eQuestion69',
  E_QUESTION_70: 'eQuestion70',
  E_QUESTION_71: 'eQuestion71',
  E_QUESTION_72: 'eQuestion72',
  E_QUESTION_73: 'eQuestion73',
  E_QUESTION_74: 'eQuestion74',
  E_QUESTION_75: 'eQuestion75',
  E_QUESTION_76: 'eQuestion76',
  E_QUESTION_77: 'eQuestion77',
  E_QUESTION_78: 'eQuestion78',
  E_QUESTION_79: 'eQuestion79',
  E_QUESTION_80: 'eQuestion80',
  E_QUESTION_81: 'eQuestion81',
  E_QUESTION_82: 'eQuestion82',

  E_QUESTION_83: 'eQuestion83',
  E_QUESTION_84: 'eQuestion84',
  E_QUESTION_85: 'eQuestion85',
  E_QUESTION_86: 'eQuestion86',
  E_QUESTION_87: 'eQuestion87',
  E_QUESTION_88: 'eQuestion88',
  E_QUESTION_89: 'eQuestion89',
  E_QUESTION_90: 'eQuestion90',
  E_QUESTION_91: 'eQuestion91',
  E_QUESTION_92: 'eQuestion92',
  E_QUESTION_93: 'eQuestion93',
  E_QUESTION_94: 'eQuestion94',
  E_QUESTION_95: 'eQuestion95',
  E_QUESTION_96: 'eQuestion96',
  E_QUESTION_97: 'eQuestion97',
  E_QUESTION_98: 'eQuestion98',
  E_QUESTION_99: 'eQuestion99',
  E_QUESTION_100: 'eQuestion100',
  E_QUESTION_101: 'eQuestion101',
  E_QUESTION_102: 'eQuestion102',
  E_QUESTION_103: 'eQuestion103',
  E_QUESTION_104: 'eQuestion104',
  E_QUESTION_105: 'eQuestion105',
  E_QUESTION_106: 'eQuestion106',
  E_QUESTION_107: 'eQuestion107',
  E_QUESTION_108: 'eQuestion108',
  E_QUESTION_109: 'eQuestion109',
  E_QUESTION_110: 'eQuestion110',
  E_QUESTION_111: 'eQuestion111',
  E_QUESTION_112: 'eQuestion112',
  E_QUESTION_113: 'eQuestion113',
  E_QUESTION_114: 'eQuestion114',
  E_QUESTION_115: 'eQuestion115'
};

export const EmployeesLabel = {
  E_HEADINGLABEL_1: '20. Details as at the end of Financial Year:',
  E_HEADINGLABEL_2: '21. Participation/Inclusion/Representation of women',
  E_HEADINGLABEL_3: '22. Turnover rate for permanent employees and workers',

  E_QUESTION_1: 'Total Male Employees',
  E_QUESTION_2: 'Total Female Employees',
  E_QUESTION_3: 'Permanent Male Employees',
  E_QUESTION_4: 'Permanent Female Employees',
  E_QUESTION_5: 'Total Male Workers',
  E_QUESTION_6: 'Total Female Workers',
  E_QUESTION_7: 'Permanent Male Workers',
  E_QUESTION_8: 'Permanent Female Workers',
  E_QUESTION_9: 'Total Male Employees',
  E_QUESTION_10: 'Total Female Employees',
  E_QUESTION_11: 'Permanent Male Employees',
  E_QUESTION_12: 'Permanent Female Employees',
  E_QUESTION_13: 'Total Male Workers',
  E_QUESTION_14: 'Total Female Workers',
  E_QUESTION_15: 'Permanent Male Workers',
  E_QUESTION_16: 'Permanent Female Workers',
  E_QUESTION_17: 'Total Board of Directors',
  E_QUESTION_18: 'No. of Females on Board of Directors',
  E_QUESTION_19: 'Total Key Management Personnel',
  E_QUESTION_20: 'No. of Females on Key Management Personnel',
  E_QUESTION_21: `${FY.previousToPrevious}`,
  E_QUESTION_22:
    'No. of Male Permanent Employees left the organization in the year',
  E_QUESTION_23:
    'No. of Females Permanent Employees left the organization in the year',
  E_QUESTION_24: 'No. of Males Permanent Employees',
  E_QUESTION_25: 'No. of Females Permanent Employees',
  E_QUESTION_26: `${FY.previous}`,
  E_QUESTION_27:
    'No. of Male Permanent Employees left the organization in the year',
  E_QUESTION_28:
    'No. of Females Permanent Employees left the organization in the year',
  E_QUESTION_29: `${FY.current}`,
  E_QUESTION_30:
    'No. of Male Permanent Employees left the organization in the year',
  E_QUESTION_31:
    'No. of Females Permanent Employees left the organization in the year',
  E_QUESTION_32: `${FY.previousToPrevious}`,
  E_QUESTION_33:
    'No. of Male Permanent Workers left the organization in the year',
  E_QUESTION_34:
    'No. of Females Permanent Workers left the organization in the year',
  E_QUESTION_35: 'No. of Males Permanent Workers',
  E_QUESTION_36: 'No. of Females Permanent Workers',
  E_QUESTION_37: `${FY.previous}`,
  E_QUESTION_38:
    'No. of Male Permanent Workers left the organization in the year',
  E_QUESTION_39:
    'No. of Females Permanent Workers left the organization in the year',
  E_QUESTION_40: `${FY.current}`,
  E_QUESTION_41:
    'No. of Male Permanent Workers left the organization in the year',
  E_QUESTION_42:
    'No. of Females Permanent Workers left the organization in the year',

  E_HEADING_1: 'a. Employees and workers (including differently abled) :',
  E_HEADING_2: 'Employees info',
  E_HEADING_3: 'Total Employees',
  E_HEADING_4: 'Permanent Employees',
  E_HEADING_5: 'Other Than Permanent Employees',
  E_HEADING_6: '% Male Permanent Employees',
  E_HEADING_7: '% Female Permanent Employees',
  E_HEADING_8: 'Workers info',
  E_HEADING_9: 'Total Workers',
  E_HEADING_10: 'Permanent Workers',
  E_HEADING_11: 'Other Than Permanent Workers',
  E_HEADING_12: '% Male Permanent Workers',
  E_HEADING_13: '% Female Permanent Workers',
  E_HEADING_14: 'b. Differently abled Employees and workers :',
  E_HEADING_15: 'Differently Abled Employees info',
  E_HEADING_16: 'Differently Abled Workers info',
  E_HEADING_17: 'Females on Board of Directors',
  E_HEADING_18: 'Females on Key Management Personnel',
  E_HEADING_19: `Total turnover rate in (${FY.previousToPrevious})`,
  E_HEADING_20: `Total turnover rate in (${FY.previous})`,
  E_HEADING_21: `Total turnover rate in (${FY.current})`,
  E_HEADING_22: 'Other Than Permanent Male Employees',
  E_HEADING_23: 'Other Than Permanent Female Employees',
  E_HEADING_24: '% Other Than Permanent Male Employees',
  E_HEADING_25: '% Other Than Permanent Female Employees',
  E_HEADING_26: '% Total Male Employees',
  E_HEADING_27: '% Total Female Employees',
  E_HEADING_28: 'Other Than Permanent Male Workers',
  E_HEADING_29: 'Other Than Permanent Female Workers',
  E_HEADING_30: '% Other Than Permanent Male Workers',
  E_HEADING_31: '% Other Than Permanent Female Workers',
  E_HEADING_32: '% Total Male Workers',
  E_HEADING_33: '% Total Female Workers',
  E_HEADING_34: `Male turnover rate in (${FY.current})`,
  E_HEADING_35: `Female turnover rate in (${FY.current})`,
  E_HEADING_36: `Male turnover rate in (${FY.previous})`,
  E_HEADING_37: `Female turnover rate in (${FY.previous})`,
  E_HEADING_38: `Male turnover rate in (${FY.previousToPrevious})`,
  E_HEADING_39: `Female turnover rate in (${FY.previousToPrevious})`
};

// holdingSubsidiaryAndAssociateCompanies----------------------------------
export const HoldingSubsidiaryAndAssociateCompaniesKey = {
  HSAAC_QUESTION_1: 'hsaacQuestion1',
  HSAAC_QUESTION_2: 'hsaacQuestion2',
  HSAAC_QUESTION_3: 'hsaacQuestion3',
  HSAAC_QUESTION_4: 'hsaacQuestion4',
  HSAAC_QUESTION_5: 'hsaacQuestion5',
  HSAAC_QUESTION_6: 'hsaacQuestion6',
  HSAAC_QUESTION_7: 'hsaacQuestion7',
  HSAAC_QUESTION_8: 'hsaacQuestion8',
  HSAAC_QUESTION_9: 'hsaacQuestion9',
  HSAAC_QUESTION_10: 'hsaacQuestion10',
  HSAAC_QUESTION_11: 'hsaacQuestion11'
};

export const HoldingSubsidiaryAndAssociateCompaniesLabel = {
  HSAAC_HEADINGLABEL_1:
    '23. (a) Name of the holding / subsidiary / associate companies / joint ventures (A) ',
  HSAAC_HEADING_1:
    'Name of the holding / subsidiary / associate companies / joint ventures (A)',
  HSAAC_HEADING_2:
    'Indicate whether holding / Subsidiary / Associate / Joint Venture',
  HSAAC_HEADING_3: '% of shares held by listed entity',
  HSAAC_HEADING_4:
    'Does the entity indicated at column A, participate in the Business Responsibility initiatives of the listed entity? (Yes/No)',
  HSAAC_QUESTION_1: '',
  HSAAC_QUESTION_2: '',
  HSAAC_QUESTION_3: '',
  HSAAC_QUESTION_4: '',
  HSAAC_QUESTION_5: '',
  HSAAC_QUESTION_6: '',
  HSAAC_QUESTION_7: '',
  HSAAC_QUESTION_8: '',
  HSAAC_QUESTION_9: '',
  HSAAC_QUESTION_10: ''
};

// CSRDetails----------------------------------
export const CSRDetailsKey = {
  CSRD_QUESTION_1: 'csrdQuestion1',
  CSRD_QUESTION_1_yes: 'csrdQuestion1_yes',
  CSRD_QUESTION_2: 'csrdQuestion2',
  CSRD_QUESTION_3: 'csrdQuestion3',
  CSRD_QUESTION_4: 'csrdQuestion4',
  CSRD_QUESTION_5: 'csrdQuestion5',
  CSRD_QUESTION_6: 'csrdQuestion6',
  CSRD_QUESTION_7: 'csrdQuestion7',
  CSRD_QUESTION_8: 'csrdQuestion8',
  CSRD_QUESTION_9: 'csrdQuestion9',
  CSRD_QUESTION_10: 'csrdQuestion10'
};

export const CSRDetailsLabel = {
  CSRD_HEADING_1:
    '24. i. Whether CSR is applicable as per section 135 of Companies Act, 2013 :',
  CSRD_HEADING_2: 'ii. Turnover (in Rs.) :',
  CSRD_HEADING_3: 'iii. Net worth (in Rs.) :',

  CSRD_QUESTION_1: '',
  CSRD_QUESTION_2: '',
  CSRD_QUESTION_3: '',
  CSRD_QUESTION_4: '',
  CSRD_QUESTION_5: '',
  CSRD_QUESTION_6: '',
  CSRD_QUESTION_7: '',
  CSRD_QUESTION_8: '',
  CSRD_QUESTION_9: '',
  CSRD_QUESTION_10: ''
};

// transparencyAndDisclosuresCompliances----------------------------------
export const TransparencyAndDisclosuresCompliancesKey = {
  TADC_QUESTION_1: 'tadcQuestion1',
  TADC_QUESTION_2: 'tadcQuestion2',
  TADC_QUESTION_3: 'tadcQuestion3',
  TADC_QUESTION_4: 'tadcQuestion4',
  TADC_QUESTION_5: 'tadcQuestion5',
  TADC_QUESTION_6: 'tadcQuestion6',
  TADC_QUESTION_7: 'tadcQuestion7',
  TADC_QUESTION_8: 'tadcQuestion8',
  TADC_QUESTION_9: 'tadcQuestion9',
  TADC_QUESTION_10: 'tadcQuestion10',
  TADC_QUESTION_11: 'tadcQuestion11',
  TADC_QUESTION_12: 'tadcQuestion12',
  TADC_QUESTION_13: 'tadcQuestion13',
  TADC_QUESTION_14: 'tadcQuestion14',
  TADC_QUESTION_15: 'tadcQuestion15',
  TADC_QUESTION_16: 'tadcQuestion16',
  TADC_QUESTION_17: 'tadcQuestion17',
  TADC_QUESTION_18: 'tadcQuestion18',
  TADC_QUESTION_19: 'tadcQuestion19',
  TADC_QUESTION_20: 'tadcQuestion20',
  TADC_QUESTION_21: 'tadcQuestion21',
  TADC_QUESTION_22: 'tadcQuestion22',
  TADC_QUESTION_23: 'tadcQuestion23',
  TADC_QUESTION_24: 'tadcQuestion24',
  TADC_QUESTION_25: 'tadcQuestion25',
  TADC_QUESTION_26: 'tadcQuestion26',
  TADC_QUESTION_27: 'tadcQuestion27',
  TADC_QUESTION_28: 'tadcQuestion28',
  TADC_QUESTION_29: 'tadcQuestion29',
  TADC_QUESTION_30: 'tadcQuestion30',
  TADC_QUESTION_31: 'tadcQuestion31',
  TADC_QUESTION_32: 'tadcQuestion32',
  TADC_QUESTION_33: 'tadcQuestion33',
  TADC_QUESTION_34: 'tadcQuestion34',
  TADC_QUESTION_35: 'tadcQuestion35',
  TADC_QUESTION_36: 'tadcQuestion36',
  TADC_QUESTION_37: 'tadcQuestion37',
  TADC_QUESTION_38: 'tadcQuestion38',
  TADC_QUESTION_39: 'tadcQuestion39',
  TADC_QUESTION_40: 'tadcQuestion40',
  TADC_QUESTION_41: 'tadcQuestion41',
  TADC_QUESTION_42: 'tadcQuestion42',
  TADC_QUESTION_43: 'tadcQuestion43',
  TADC_QUESTION_44: 'tadcQuestion44',
  TADC_QUESTION_45: 'tadcQuestion45',
  TADC_QUESTION_46: 'tadcQuestion46',
  TADC_QUESTION_47: 'tadcQuestion47',
  TADC_QUESTION_48: 'tadcQuestion48',
  TADC_QUESTION_49: 'tadcQuestion49',
  TADC_QUESTION_50: 'tadcQuestion50',
  TADC_QUESTION_51: 'tadcQuestion51',
  TADC_QUESTION_52: 'tadcQuestion52',
  TADC_QUESTION_53: 'tadcQuestion53',
  TADC_QUESTION_54: 'tadcQuestion54',
  TADC_QUESTION_55: 'tadcQuestion55',

  TADC_COLUMN_1: 'tadcColumn1',
  TADC_COLUMN_2: 'tadcColumn2',
  TADC_COLUMN_3: 'tadcColumn3',
  TADC_COLUMN_4: 'tadcColumn4',
  TADC_COLUMN_5: 'tadcColumn5'
};

export const TransparencyAndDisclosuresCompliancesLabel = {
  TADC_HEADING_LABEL_1:
    '25. Complaints/Grievances on any of the principles (Principles 1 to 9) under the National Guidelines on Responsible Business Conduct:',
  TADC_HEADING_LABEL_2:
    '26. Overview of the entity’s material responsible business conduct issues',

  TADC_HEADING_1: 'Communities',
  TADC_HEADING_2: `${FY.current}`,
  TADC_HEADING_3: `${FY.previous}`,
  TADC_HEADING_4: 'Investors (other than shareholders)',
  TADC_HEADING_5: 'Shareholders',
  TADC_HEADING_6: 'Value Chain Partners',
  TADC_HEADING_7: 'Other (please specify)',
  TADC_HEADING_8: 'Material issue identified',
  TADC_HEADING_9: 'Employees and workers',
  TADC_HEADING_10: 'Customers',

  TADC_QUESTION_2: 'No. of complaints filed',
  TADC_QUESTION_3: 'No. of unresolved complaints at year-end',
  TADC_QUESTION_4: 'Remarks',

  TADC_QUESTION_5: 'Material issue identified',
  TADC_QUESTION_6: 'Indicate whether risk or opportunity',
  TADC_QUESTION_7: 'Rationale for identifying the risk / opportunity',
  TADC_QUESTION_8: 'In case of risk, approach to adapt or mitigate',
  TADC_QUESTION_9:
    'Financial implications of the risk or opportunity (Indicate positive or negative implications)',

  TADC_QUESTION_10: 'Grievance Redressal Mechanism in Place (Yes/No)'
};
